import { useEffect, useState } from 'react';
import { IInstrumento, InstrumentsServices } from '../../services/api/instruments/InstrumentosServices';
import { Select, MenuItem, FormControl, InputLabel, SelectChangeEvent } from '@mui/material';

type VListInstrumentsProps = {
    id_dam: string | undefined;
    type?: string;
    changeSelectInstrument?: (selectUuid: string) => void;
}

export const VListInstruments = ({id_dam, type, changeSelectInstrument}: VListInstrumentsProps) => {

    const [ data, setData ] = useState<IInstrumento[]>([]);
    const [ selectUuid, setSelectUuid ] = useState<string>('');

    useEffect(() => {
        id_dam !== undefined ? fetchData(id_dam) : null;
    }, [type]);

    function fetchData(id_dam: string){
        try {
            InstrumentsServices.get(id_dam).then((result) => {
                if(result instanceof Error){
                    alert(result.message);
                }else{
                    if(type){
                        const filter = result.filter(index => index.tipo_instrumento === type);
                        setData(filter);
                    }
                }
            });
        }catch (error){
            console.log(error);
        }
    }
    
    function handleSelect(event: SelectChangeEvent) {
        const uuid = event.target.value as string;
        setSelectUuid(uuid);
        if(changeSelectInstrument){
            changeSelectInstrument(uuid);
        }
    }

    return(
        <FormControl fullWidth>
            <InputLabel>Instrumento</InputLabel>
            <Select label="Instrumento" fullWidth onChange={handleSelect} value={selectUuid}>
                {data.map((instrumento) => (
                    <MenuItem key={instrumento.uuid} value={instrumento.uuid}>
                        {instrumento.nome}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};